import axios from 'lib/axios'

const getSkillsReport = async (userTestId: number) => {
  const PATH = `${process.env.REACT_APP_MAIN_API}/pdf/3d-skills`
  const data = {
    user_test_id: userTestId,
  }
  try {
    const response = await axios.post(PATH, data)
    if (!response?.data?.url) {
      throw new Error('No se recibió la URL del reporte de 3D Skills')
    }
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export default getSkillsReport
